__turbopack_context__.v({
  "container": "month-actions-module-scss-module__fmPMcq__container",
  "container-flat": "month-actions-module-scss-module__fmPMcq__container-flat",
  "container-popover": "month-actions-module-scss-module__fmPMcq__container-popover",
  "container-popover__mobile": "month-actions-module-scss-module__fmPMcq__container-popover__mobile",
  "month-button": "month-actions-module-scss-module__fmPMcq__month-button",
  "month-name": "month-actions-module-scss-module__fmPMcq__month-name",
  "month-name-divider": "month-actions-module-scss-module__fmPMcq__month-name-divider",
  "month-name-flat": "month-actions-module-scss-module__fmPMcq__month-name-flat",
  "month-name-flat__mobile": "month-actions-module-scss-module__fmPMcq__month-name-flat__mobile",
  "month-name-native": "month-actions-module-scss-module__fmPMcq__month-name-native",
  "month-name-popover": "month-actions-module-scss-module__fmPMcq__month-name-popover",
  "rtl": "month-actions-module-scss-module__fmPMcq__rtl",
});
